import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@com/utils/storage'

export const language = {
  set(val: string) {
    setLocalStorage('language', val)
  },
  get() {
    return getLocalStorage('language') || navigator.language.toLowerCase()
  },
  remove() {
    removeLocalStorage('language')
  },
}
